import configureStore from 'redux/config';

const { store, persistor } = configureStore();

export { store, persistor }